import { FetchItemGqlQuery, ID, NanoID, UUID } from '../../../../../types';

import { generateUuid } from '../../../../../utils/generateUuid';
import { getQueryName } from '../../../../../utils/getQueryName';
import { productionConsole } from '../../../../../utils/productionConsole';

import { graphQLEdClient } from '../../graphQLClients';

interface FetchEdItemProps {
  query: FetchItemGqlQuery;
  uid: UUID | NanoID | ID;
}

export function fetchEdItem({ query, uid }: FetchEdItemProps) {
  const { rawName, name } = getQueryName(query);

  productionConsole('log', 'fetchEdItem', uid, { rawName, name });

  const requestId = generateUuid();

  graphQLEdClient.addQueryParams(name, requestId);

  return graphQLEdClient.request(query, { uid }, { requestId });
}
